module.exports = __webpack_public_path__ + "static/power-img2-2-f20a6e46189bee155610f05d27f6fc34.png";